import React from 'react';
import { useField } from 'formik';
import { CommissionShare } from '@models/Commission';
import { CommissionShareInput } from './CommissionShareInput';

export type CommissionShareFieldProps = {
  name: string;
  currentUserId: number;
  currentUserName: string;
  disabled?: boolean;
};

export const CommissionShareField = ({
  name,
  currentUserId,
  currentUserName,
  disabled = false,
}: CommissionShareFieldProps) => {
  const [field, , helpers] = useField<CommissionShare[]>(name);

  const currentUser = {
    id: currentUserId,
    name: currentUserName,
  };

  const value = field.value || [
    {
      userId: currentUserId,
      userName: currentUserName,
      commissionSharePercentage: 100,
    },
  ];

  const handleChange = (shares: CommissionShare[]) => {
    void helpers.setValue(shares);
  };

  return <CommissionShareInput currentUser={currentUser} value={value} onChange={handleChange} disabled={disabled} />;
};
